import _styled from "@emotion/styled/base";
var _excluded = ["children"];

function cov_2abro87rr() {
  var path = "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx";
  var hash = "4dd6ef7fb1560a8ad5f4989544c1dc6e3a698cdb";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/cinderblocks/src/platform/auth/shared.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 35
        },
        end: {
          line: 19,
          column: 73
        }
      },
      "1": {
        start: {
          line: 21,
          column: 54
        },
        end: {
          line: 31,
          column: 1
        }
      },
      "2": {
        start: {
          line: 22,
          column: 2
        },
        end: {
          line: 30,
          column: 4
        }
      },
      "3": {
        start: {
          line: 33,
          column: 71
        },
        end: {
          line: 35,
          column: 1
        }
      },
      "4": {
        start: {
          line: 34,
          column: 2
        },
        end: {
          line: 34,
          column: 80
        }
      },
      "5": {
        start: {
          line: 37,
          column: 48
        },
        end: {
          line: 39,
          column: 1
        }
      },
      "6": {
        start: {
          line: 38,
          column: 2
        },
        end: {
          line: 38,
          column: 65
        }
      },
      "7": {
        start: {
          line: 41,
          column: 48
        },
        end: {
          line: 43,
          column: 1
        }
      },
      "8": {
        start: {
          line: 42,
          column: 2
        },
        end: {
          line: 42,
          column: 36
        }
      },
      "9": {
        start: {
          line: 45,
          column: 52
        },
        end: {
          line: 47,
          column: 1
        }
      },
      "10": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 46,
          column: 42
        }
      },
      "11": {
        start: {
          line: 49,
          column: 46
        },
        end: {
          line: 55,
          column: 1
        }
      },
      "12": {
        start: {
          line: 50,
          column: 2
        },
        end: {
          line: 54,
          column: 8
        }
      },
      "13": {
        start: {
          line: 57,
          column: 20
        },
        end: {
          line: 64,
          column: 1
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 21,
            column: 54
          },
          end: {
            line: 21,
            column: 55
          }
        },
        loc: {
          start: {
            line: 21,
            column: 65
          },
          end: {
            line: 31,
            column: 1
          }
        },
        line: 21
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 33,
            column: 71
          },
          end: {
            line: 33,
            column: 72
          }
        },
        loc: {
          start: {
            line: 33,
            column: 82
          },
          end: {
            line: 35,
            column: 1
          }
        },
        line: 33
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 37,
            column: 48
          },
          end: {
            line: 37,
            column: 49
          }
        },
        loc: {
          start: {
            line: 37,
            column: 59
          },
          end: {
            line: 39,
            column: 1
          }
        },
        line: 37
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 41,
            column: 48
          },
          end: {
            line: 41,
            column: 49
          }
        },
        loc: {
          start: {
            line: 41,
            column: 59
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 41
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 45,
            column: 52
          },
          end: {
            line: 45,
            column: 53
          }
        },
        loc: {
          start: {
            line: 45,
            column: 63
          },
          end: {
            line: 47,
            column: 1
          }
        },
        line: 45
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 49,
            column: 46
          },
          end: {
            line: 49,
            column: 47
          }
        },
        loc: {
          start: {
            line: 50,
            column: 2
          },
          end: {
            line: 54,
            column: 8
          }
        },
        line: 50
      }
    },
    branchMap: {},
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "4dd6ef7fb1560a8ad5f4989544c1dc6e3a698cdb"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_2abro87rr = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_2abro87rr();

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/react';
import { Box, Text, Flex, Heading } from '@opendoor/bricks/core';
import { space } from '@opendoor/bricks/theme/eero';
import { UNSAFE_SingleLineInputWrapper } from '@opendoor/bricks/deprecated/UNSAFE_SingleLineInput';
export var INVALID_EMAIL_ERROR = (cov_2abro87rr().s[0]++, "Looks like this isn't a valid email.");
cov_2abro87rr().s[1]++;
export var AccountFormWrapper = function AccountFormWrapper(props) {
  cov_2abro87rr().f[0]++;
  cov_2abro87rr().s[2]++;
  return jsx(Box, _extends({
    width: "100%",
    maxWidth: "500px",
    padding: [7, 7, 0],
    textAlign: ['left', 'left', 'center']
  }, props));
};
cov_2abro87rr().s[3]++;
export var AccountFormHeader = function AccountFormHeader(props) {
  cov_2abro87rr().f[1]++;
  cov_2abro87rr().s[4]++;
  return jsx(Heading, _extends({
    size: "h2",
    mb: 7,
    fontSize: ['s3', 'UNSAFE_h2']
  }, props));
};
cov_2abro87rr().s[5]++;
export var FormWrapper = function FormWrapper(props) {
  cov_2abro87rr().f[2]++;
  cov_2abro87rr().s[6]++;
  return jsx(Flex, _extends({
    width: "100%",
    flexDirection: "column"
  }, props));
};
cov_2abro87rr().s[7]++;
export var BodyWrapper = function BodyWrapper(props) {
  cov_2abro87rr().f[3]++;
  cov_2abro87rr().s[8]++;
  return jsx(Text, _extends({
    my: 2
  }, props));
};
cov_2abro87rr().s[9]++;
export var CtaButtonWrapper = function CtaButtonWrapper(props) {
  cov_2abro87rr().f[4]++;
  cov_2abro87rr().s[10]++;
  return jsx(Box, _extends({
    mt: 9,
    mb: 5
  }, props));
};
cov_2abro87rr().s[11]++;
export var Disclaimer = function Disclaimer(_ref) {
  var children = _ref.children,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_2abro87rr().f[5]++;
  cov_2abro87rr().s[12]++;
  return jsx(Box, _extends({
    mt: 9
  }, props), jsx(Text, {
    fontSize: "s00",
    lineHeight: "s000",
    color: "neutrals90"
  }, children));
};
export var Form = (cov_2abro87rr().s[13]++, _styled("form", process.env.NODE_ENV === "production" ? {
  target: "e1a669rm0"
} : {
  target: "e1a669rm0",
  label: "Form"
})("width:100%;margin-top:", space[7], ";", UNSAFE_SingleLineInputWrapper, "{margin:", space[5], "px 0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")));